/**
 * Deprecated jobs list.
 *
 * @constant
 * @type {Array<string>}
 */
const deprecatedJobs = [
  'Unreal Engine developer (RU)',
  'QA Engineer (auto) (RU)',
  'JS - Frontend developer Junior (RU)',
  'Accountant (RU)',
  'Frontend developer - HTML/CSS/JS (RU)',
  'Frontend developer - HTML/CSS/JS (part time) (RU)',
];

export default deprecatedJobs;



// WEBPACK FOOTER //
// ./src/constants/deprecated-jobs.js